import { Button, Col, Row } from "antd";
import styled from "styled-components";

export const Wrapper = styled(Col)`
  width: 368px;
  padding: 24px;
  border-radius: 16px;
  background-color: ${"#fafafa"};

  .title {
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
`;

export const TextRow = styled(Row)`
  color: ${"#8c8c8c"};

  .typography {
    color: inherit;
    line-height: 24px;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ProgressRow = styled(Row)`
  margin-top: 16px;

  .col-first-child {
    width: 244px;
  }
`;

export const StyledButton = styled(Button)`
  padding: 0;
  font-weight: 500;
`;
